module.exports = __webpack_public_path__ + "media/landing-page/bg-hero-5-min-58279325.svg";